import { Value } from "@core/components/Value";
import { PlayValue } from "./sheet";
import { useSm } from "./view";

/** Boxes of a track not struck off, of all boxes, with a bar for a quick look. */
function TrackLeft(props: { label: string; available: string; total: string }) {
  const { value } = useSm();
  return (
    <div className="group-track">
      <span className="group-track-label">{props.label}</span>
      <Value valueKey={props.available} label={`${props.label} verfügbar`} />
      <span className="muted small">von</span>
      <Value valueKey={props.total} label={`${props.label} gesamt`} />
      <meter min={0} max={value(props.total)?.number ?? 0} value={value(props.available)?.number ?? 0} aria-hidden="true" />
    </div>
  );
}

/** What the game master asks for most: life and focus left, health level and the defenses, all as they count during play. */
export function GroupCard() {
  const { view, value } = useSm();
  const { life, focus } = view.losses;
  const health = life.levels.find((l) => l.level === value(life.level)?.number);
  const hurt = (value(life.penalty)?.number ?? 0) !== 0;
  return (
    <div className="group-values">
      <TrackLeft label="Lebenspunkte" available={life.available} total={life.boxes} />
      <p className={`group-health small${hurt ? " hurt" : ""}`}>
        <span>{health?.name ?? "–"}</span>
        {hurt && <Value valueKey={life.penalty} label="Wundabzug" showLabel />}
      </p>
      <TrackLeft label="Fokus" available={focus.available} total={focus.boxes} />
      <div className="play-values">
        {["vtd", "gw", "kw", "ini", "gsw"].map((id) => {
          const derived = view.derived.find((d) => d.id === id);
          return derived ? <PlayValue key={id} base={derived.value} play={derived.play} label={derived.short} showLabel /> : null;
        })}
        <Value valueKey="splitterpunkte" label="SP" showLabel />
      </div>
    </div>
  );
}
